import React, { useEffect, useState } from 'react';
import Sidebar from '../components/ui/Sidebar';
import API_URL from '../config';
import useScreenWidth from '../hooks/useScreenWidth';
import { FaUser } from 'react-icons/fa';


const Historial = () => {
  const [movimientos, setMovimientos] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState('');
 
  // Recorrer contenido si el sidebar de oculta
  const screenWidth = useScreenWidth();
  const [sidebarVisible, setSidebarVisible] = useState(screenWidth >= 768);

 // Estilo para las columnas de la tabla
const styles = {
    tableHeader: {
      backgroundColor: '#a3bac0', // Cambia este color según tus preferencias
      color: '#333', // Color del texto
      fontWeight: 'bold', // Negrita
      padding: '15px', // Espacio interno de las celdas
    },
    tableRow: {
      backgroundColor: '#daeeeeff', // Cambia este color según tus preferencias
      color: '#333', // Color del texto
      padding: '12px', // Espacio interno de las celdas
    },
    tableRowAlt: {
      backgroundColor: '#f0fbfbff', // Cambia este color según tus preferencias
      color: '#333', // Color del texto
      padding: '12px', // Espacio interno de las celdas
    },
  };


  useEffect(() => {
    fetch(`${API_URL}/api/movimientos`)
      .then(r => r.json())
      .then(setMovimientos)
      .catch(console.error);
  }, []);


const movimientosFiltrados = movimientos.filter(m =>
  sucursalSeleccionada
    ? m.sucursal.trim().toLowerCase() === sucursalSeleccionada.trim().toLowerCase()
    : true
);


  return (
    <div style={{ display: 'flex' }}>
    <Sidebar sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible} />      
    <main
            style={{
              flex: 1,
              minHeight: '100vh',
              overflowX: 'auto',
              overflowY: 'visible',
              marginLeft: sidebarVisible ? '180px' : '0',
              padding: '2rem',
              backgroundColor: '#edf0f0',
              position: 'relative',
            }}
          >
          {/* Usuario + icono (arriba a la derecha) */}
              <div
                style={{
                  position: 'absolute',
                  top: '1.2rem',
                  right: '2rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: '0.95rem',
                  color: '#333',
                  zIndex: 1001,
                }}
              >
                <FaUser
                  style={{
                    fontSize: '2.2rem',
                    color: '#333',
                    verticalAlign: 'middle',
                  }}
                />
                <span>
                  {localStorage.getItem('user')
                    ? JSON.parse(localStorage.getItem('user')).username
                    : 'Usuario'}
                </span>
              </div>

            {/* Título centrado */}
            <h2 style={{ textAlign: 'center', margin: '2.2rem auto 1.5rem' }}>Historial de movimientos</h2>
            <p
              style={{
                fontSize: '0.9rem',
                color: '#666',
                marginBottom: '1rem',
                textAlign: 'center'
              }}
            >
              Desliza horizontalmente para ver toda la tabla en dispositivos móviles.
            </p>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: '30px',
            padding: '0.6rem 1.2rem',
            width: '90%',
            maxWidth: '800px',
            margin: '0 auto 2rem',
            boxShadow: '0 2px 6px rgba(0,0,0,.08)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.02)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,.08)';
          }}
        >
          <select
            value={sucursalSeleccionada}
            onChange={(e) => setSucursalSeleccionada(e.target.value)}
            style={{
              border: 'none',
              outline: 'none',
              flex: 1,
              fontSize: '1rem',
              fontFamily: "'Poppins', sans-serif",
              background: 'transparent',
              color: '#333',
              padding: '0.4rem 0',
              cursor: 'pointer',
            }}
          >
            <option value="">Selecciona una sucursal</option>
            <option value="1. Matriz Zaragoza">1. Matriz Zaragoza</option>
            <option value="2. Suc. Cuervos">2. Suc. Cuervos</option>
            <option value="3. Suc. Hosp. Gral">3. Suc. Hosp. Gral</option>
            <option value="4. Suc. Cd. Gpe. Victoria">4. Suc. Cd. Gpe. Victoria</option>
            <option value="5. Suc. Ejido Hermosillo">5. Suc. Ejido Hermosillo</option>
            <option value="6. Suc. Alliance Medical">6. Suc. Alliance Medical</option>
            <option value="7. Suc. Madero y 12">7. Suc. Madero y 12</option>

          </select>
        </div>
          {/* Botón hamburguesa (visible para todos) */}
        {!sidebarVisible && (
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <button
              onClick={() => setSidebarVisible(true)}
              style={{
                background: '#1f3339',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '0.6rem 1.2rem',
                fontSize: '1rem',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                minWidth: '150px',
              }}
            >
              ☰ Menú
            </button>
          </div>
        )}


            {/* Contenedor responsivo con tabla */}
          <div
            style={{
              overflowX: 'auto',
              width: '100%',
              borderRadius: '16px',
              boxShadow: '0 4px 12px rgba(0,0,0,.06)',
              background: '#fff',
              padding: '1.5rem',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.005)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,.06)';
            }}
          >

            

        <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0,.06)', padding: '1.5rem' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f9f9f9', borderBottom: '2px solid #e0e0e0' }}>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Fecha</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Tipo</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Producto</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Sucursal</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Usuario</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Cantidad</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Presentación</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Marca</th>
                <th style={{ ...styles.tableHeader, textAlign: 'center' }}>Lote</th>

                
              </tr>
            </thead>
            <tbody>
              {movimientosFiltrados.map((m, index) => (
                <tr key={m.id} style={{ borderBottom: '1px solid #eee', ...(index % 2 === 0 ? styles.tableRow : styles.tableRowAlt) }}>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{new Date(m.fecha_movimiento).toLocaleDateString()}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.tipo_producto}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.producto}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.sucursal}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.usuario}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.cantidad}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.presentacion}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.marca}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{m.lote || '–'}</td>
                </tr>
              ))}
            </tbody>
          </table>
         </div>
        </div>
      </main>
    </div>
  );
};

export default Historial;
